<div class="mobile-checkbox-container position-relative d-inline-block">
    <!-- Visually Hidden Checkbox for Accessibility -->
    <input
        type="checkbox"
        class="visually-hidden-checkbox position-absolute"
        [id]="'mobile-checkbox-' + getItemId()"
        [checked]="isSelected()"
        [disabled]="isDisabled()"
        [attr.aria-label]="getAriaLabel()"
        (change)="onCheckboxChange($event)"
        (click)="$event.stopPropagation()"
    />
    
    <!-- Visual Checkbox Display -->
    @if(isDisabled() == false) {
        <div [class]="checkboxClass"
            (click)="checkboxClicked()"
            [attr.aria-hidden]="true"
            role="presentation">

        
            @if(isSelected() == true) {
            <div id="checkboxSelected" class="symbol symbol-50px symbol-circle cursor-pointer">
                <div class="mx-auto fs-4 fw-semibold symbol-label" [style.background-color]="backgroundColor">
                    <fa-duotone-icon icon="check" secondaryOpacity="1" />
                </div>
            </div>
            }
            @else {
                <div class="symbol symbol-50px symbol-circle cursor-pointer">
                    <div class="mx-auto fs-4 fw-semibold symbol-label" [style.background-color]="backgroundColor">
                        @if (icon()) {
                            <fa-duotone-icon [icon]="icon()!" [secondaryOpacity]="iconSecondaryOpacity()" [primaryOpacity]="iconPrimaryOpacity()" />
                        } @else {
                            &nbsp;
                        }
                    </div>
                </div>
            }
            
            
        </div>
    }
    @else {
        <div [class]="checkboxClass"
            role="presentation">

            <div class="symbol symbol-50px symbol-circle cursor-pointer">
                <div class="mx-auto fs-4 fw-semibold symbol-label" [style.background-color]="disabledHexColor">
                    @if (icon()) {
                        <fa-duotone-icon [icon]="icon()!" [secondaryOpacity]="iconSecondaryOpacity()" [primaryOpacity]="iconPrimaryOpacity()" />
                    } @else {
                        &mdash;
                    }
                </div>
            </div>
        </div>
    }

</div>